import { Navigate, useLocation, useSearchParams } from 'react-router';
import { LoginPage } from '@/components/LoginPage';
import { useAuth } from '@/context/AuthContext';

export function LoginRoute() {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const from = searchParams.get('from') || (location.state as { from?: string } | null)?.from || '/dashboard';

  if (user) {
    return <Navigate to={from} replace />;
  }

  return <LoginPage from={from} />;
}
